import { GetBankingSessionRenewalLinkService } from 'types/services';
import { m8API } from '../m8';

export const getBankingSessionRenewalLink: GetBankingSessionRenewalLinkService = async () => {
  return m8API.admin.getConsentAgreementLink();
};
